export enum GetUrlParams {
  AssetCode = 'assetCode',
  AssetId = 'assetId',
  TaskId = 'taskId',
  AssetIds = 'assetIds',
  AssetName = 'assetName',
  AssigneeIds = 'assigneeIds',
  CounterId = 'counterId',
  CounterName = 'counterName',
  Dst = 'dst',
  DuplicatedVersionId = 'duplicatedVersionId',
  EndDate = 'endDate',
  FormCategoryIds = 'formCategoryIds',
  InterventionCategoryIds = 'interventionCategoryIds',
  Mode = 'mode',
  OrderingDirection = 'ordering_direction',
  OrderingField = 'ordering_field',
  Page = 'page',
  PerPage = 'per_page',
  PeriodEnd = 'periodEnd',
  PeriodStart = 'periodStart',
  Priority = 'priority',
  Search = 'search',
  SelectTemplateId = 'selectTemplateId',
  SiteAndArea = 'siteAndArea',
  SiteAreaCode = 'siteAreaCode',
  SiteAreaId = 'siteAreaId',
  SiteAreaIds = 'siteAreaIds',
  SiteAreaName = 'siteAreaName',
  SiteCode = 'siteCode',
  SiteId = 'siteId',
  SiteIds = 'siteIds',
  SiteName = 'siteName',
  Step = 'step',
  Tab = 'tab',
  Token = 'token',
  View = 'view',
  UserId = 'userId',
}

export const PER_PAGE_KEY_DEFAULT = '10';
export const PER_PAGE_KEY_SITES = '9';

export const ORDERING_DIRECTION_ASC = 'asc';
export const ORDERING_DIRECTION_DESC = 'desc';
export const DEFAULT_ORDERING_DIRECTION = ORDERING_DIRECTION_DESC;

export const PAGINATION_PARAMS = {
  [GetUrlParams.Page]: '1',
  [GetUrlParams.PerPage]: PER_PAGE_KEY_DEFAULT,
};

export const ORDERING_PARAMS = {
  [GetUrlParams.OrderingField]: 'createdAt',
  [GetUrlParams.OrderingDirection]: ORDERING_DIRECTION_DESC,
};

export const DEFAULT_LIST_PARAMS = {
  ...PAGINATION_PARAMS,
  ...ORDERING_PARAMS,
};

export const SEARCH_PARAMS = {
  [GetUrlParams.Search]: '',
};

export type OrderingParams = {
  [GetUrlParams.OrderingField]?: string | null;
  [GetUrlParams.OrderingDirection]?: string | null;
};

export type OrderingState = [
  OrderingParams,
  (v: OrderingParams | ((prev: OrderingParams) => OrderingParams)) => void,
];

export type PaginationParams = {
  [GetUrlParams.Page]?: string | null;
  [GetUrlParams.PerPage]?: string | null;
};
export type ListParams = OrderingParams & PaginationParams;

export type PaginationState = [
  PaginationParams,
  (
    v: PaginationParams | ((prev: PaginationParams) => PaginationParams),
  ) => void,
];

export type SearchParams = {
  [GetUrlParams.Search]?: string | null;
};

export type SearchState = [
  SearchParams,
  (v: SearchParams | ((prev: SearchParams) => SearchParams)) => void,
];

export type SearchStringState = [
  string,
  (v: string | ((prev: string) => string)) => void,
];

export const DEFAULT_SEARCH_LIST_VARIABLES = {
  page: 1,
  limit: 20,
};

export const PATH_ACCESS = 'access';
export const PATH_ACCESS_GROUPS = 'access-groups';
export const PATH_ACTION_ID = ':actionId';
export const PATH_ACTIONS = 'actions';
export const PATH_ADD = 'add';
export const PATH_ANALYTICS = 'analytics';
export const PATH_APPROVALS = 'approvals';
export const PATH_AREAS = 'areas';
export const PATH_ASSETS = 'assets';
export const PATH_AUTH = 'auth';
export const PATH_CATEGORIES = 'categories';
export const PATH_CODE_OF_CONDUCT = 'code-of-conduct';
export const PATH_COMPANY_DOMAINS = 'company-domains';
export const PATH_COMPANY_PLAN = 'company-plan';
export const PATH_COUNTER = 'counter';
export const PATH_COUNTERS = 'counters';
export const PATH_CREATE_VERSION = 'create-version';
export const PATH_CUSTOMIZE = 'customize';
export const PATH_DASHBOARD = 'dashboard';
export const PATH_DATA_IMPORT = 'data-import';
export const PATH_DEPARTMENTS = 'departments';
export const PATH_DOCUMENT_ID = ':documentId';
export const PATH_DOCUMENTATION = 'documentation';
export const PATH_DUPLICATE = 'duplicate';
export const PATH_EDIT = 'edit';
export const PATH_ERROR = 'error';
export const PATH_FORM_CHECKLISTS = 'form-checklists';
export const PATH_FORM_TEMPLATES = 'form-templates';
export const PATH_FORM_TEMPLATES_ACTIVE = 'form-templates-active';
export const PATH_FORM_TEMPLATES_ARCHIVED = 'form-templates-archived';
export const PATH_HOME = 'home';
export const PATH_ID = ':id';
export const PATH_IMPORT = 'import';
export const PATH_INTERVENTIONS = 'interventions';
export const PATH_LATEST_VERSION = 'latest_version';
export const PATH_MONITORING = 'monitoring';
export const PATH_NOMENCLATURE = 'nomenclature';
export const PATH_OVERVIEW = 'overview';
export const PATH_PERFORM_TASKS = 'perform-tasks';
export const PATH_PROFILE = 'profile';
export const PATH_PUBLIC_API = 'public-api';
export const PATH_REMINDER = 'reminder';
export const PATH_REPORTING = 'reporting';
export const PATH_SECTORS = 'sectors';
export const PATH_SETUP = 'setup';
export const PATH_SITES = 'sites';
export const PATH_SSO = 'sso';
export const PATH_TASKS = 'tasks';
export const PATH_TEAMS = 'teams';
export const PATH_TIMELINE = 'timeline';
export const PATH_USERS = 'users';
export const PATH_VERSION_ID = ':versionId';
export const PATH_VIEW = 'view';
export const PATH_WIDGETS = 'widgets';
